import { createSlice } from '@reduxjs/toolkit';
import { Filter, ListDecoratedMedisanteDevice } from '../pages/Devices/types';
import { MedisanteDevice } from '../pages/Device/types';

const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export interface AppSliceState {
  deviceFilters: Filter[];
  actionMenuDevices: MedisanteDevice[];
  deviceStatusInfo: ListDecoratedMedisanteDevice | null;
}

const initialState: AppSliceState = {
  deviceFilters: [],
  actionMenuDevices: [],
  deviceStatusInfo: null,
};
const persistedState = loadState();
const AppSlice = createSlice({
  name: 'appState',
  initialState: {
    ...initialState,
    ...persistedState,
    actionMenuDevices: [], // force clear on reload
  },
  reducers: {
    setDeviceFilters(state, action) {
      state.deviceFilters = action.payload;
    },
    setActionMenuDevices(state, action) {
      state.actionMenuDevices = action.payload;
    },
    setDeviceStatusInfo(state, action) {
      state.deviceStatusInfo = action.payload;
    },
  },
});

export default AppSlice;

export const { setDeviceFilters, setActionMenuDevices, setDeviceStatusInfo } =
  AppSlice.actions;
